import React, { useCallback, useEffect, useMemo, useState } from 'react';

import AddressCard from '~/src/components/AddressCard';
import AddressList from '~/src/components/AddressList';
import CheckAddressMapConnect from '~/src/components/CheckAddressMapConnect';
import { addressCardProps } from '~/src/constants/addressCard';
import { domainProps } from '~/src/constants/addressList';
import { getDistrictDeclination } from '~/src/helpers/getDistrictDeclination';

import * as ST from './styled';

type AddressLayoutProps = {
    districts: domainProps[],
    cards: addressCardProps[],
}

const AddressLayout: React.FC<AddressLayoutProps> = ({ districts, cards }) => {
    const [isMobileSlider, setisMobileSlider] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth >= 535 && window.innerWidth <= 760) {
                setisMobileSlider(true);
            } else {
                setisMobileSlider(false);
            }
          }
    }, []);

    const sortArray = useCallback((x, y) => {
        if (x.key < y.key) {
            return -1;
        } else if (x.key > y.key) {
            return 1;
        } else {
            return 0;
        }
    }, []);

   const filteredDistricts = useMemo(() => {
        const filteredKeys = new Set();

        for (let i = 0; i <= districts.length; i++) {
            if (districts[i]) {
                filteredKeys.add(districts[i].name[0]);
            }
        }

        return Array.from(filteredKeys).map(item => ({
            key: item as string,
            values: districts.reduce((acc, el) => [
                ...acc,
                ...(el.name[0] === item
                ? [{
                        title: getDistrictDeclination(el.name, 'nominative_case', false),
                        url: el.url,
                    }]
                : []),
            ], [] as {
                title: string,
                url: string,
            }[]),
        })).sort(sortArray);
    }, [districts, sortArray]);

    return (
        <ST.AddressLayout>
            <ST.InnerContainer>
                <ST.FormTitle>Проверить адрес подключения Дом.ру</ST.FormTitle>
                <ST.CheckAdressBlock>
                    <CheckAddressMapConnect/>
                    {filteredDistricts.length ? <AddressList districts={filteredDistricts} /> : null }
                </ST.CheckAdressBlock>
                <ST.FormSubTitle>Выбирая интернет Дом.ру, вы получаете:</ST.FormSubTitle>
                {isMobileSlider
                    ? (
                        <ST.CustomSwiper
                            withoutDots
                            withoutArrows={true}
                            framePadding={'0 0 8px'}
                            slideWidth={'432px'}
                            cellSpacing={16}
                            slidesToScroll={'auto'}
                        >
                            {cards.map(item => {
                                return <AddressCard key={item.description} image={item.image} description={item.description} />;
                            })}
                        </ST.CustomSwiper>)
                    : (
                        <ST.AddressCardBlock>
                            {cards.map(item => {
                                return <AddressCard key={item.description} image={item.image} description={item.description} />;
                            })}
                        </ST.AddressCardBlock>
                )}
                <ST.AddressCardText>
                    <ST.FormDescTitle>Какой интернет-провайдер есть в моем доме?</ST.FormDescTitle>
                    <ST.Description>
                        Чтобы выбрать интернет-провайдера по адресу дома, уточните, какие операторы его обслуживают.
                        Для этого можно позвонить в техподдержку интересной вам компании и получить информацию о возможности подключения,
                        либо сэкономить время и воспользоваться онлайн-сервисом. «Проверка адреса» будет полезна тем,
                        кто переезжает или просто решил сменить провайдера. Так, чтобы узнать подключен ли ваш дом к сети Дом.ру,
                        достаточно указать адрес. Здесь же можно оставить заявку на подключение интернета по адресу дома.
                        После чего с вами свяжется менеджер и поможет подобрать оптимальный тариф.</ST.Description>
                </ST.AddressCardText>
            </ST.InnerContainer>
        </ST.AddressLayout>
    );
};

export default AddressLayout;
